module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uploader"
  }, [_c('div', {
    staticClass: "upload-progress-wrapper"
  }, [(_vm.showProgress) ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": _vm.processing
    },
    model: {
      value: (_vm.fileProgress),
      callback: function($$v) {
        _vm.fileProgress = $$v
      },
      expression: "fileProgress"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.hasFiles) ? _c('div', {
    staticClass: "center-align px-2 py-3"
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('a', {
    attrs: {
      "slot": "activator",
      "href": _vm.project.file.files.preview,
      "target": "_blank"
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "elevation-5",
    attrs: {
      "src": _vm.project.file.thumbs.medium,
      "alt": "",
      "width": "250"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Preview File")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveItem(_vm.project.file.files.preview, true)
      }
    }
  }, [_vm._v("Preview File")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center-align px-2 py-2"
  }, [_c('vue-transmit', _vm._b({
    ref: "uploader",
    on: {
      "sending": function($event) {
        _vm.showProgress = true
      },
      "upload-progress": _vm.updateProgress,
      "success": _vm.onUploadSuccess,
      "error": _vm.errorUploading,
      "timeout": _vm.onTimeout
    }
  }, 'vue-transmit', _vm.transmitOptions, false), [(_vm.hasFiles) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "large": ""
    }
  }, [_vm._v("Select a new PDF File")]) : _c('div', {
    staticClass: "upload-file-area elevation-4 v-align mb-3"
  }, [_c('br'), _vm._v(" "), _c('v-icon', {
    staticClass: "mt-3 display-3"
  }, [_vm._v("mdi-file-pdf-box")]), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        Drag & Drop"), _c('br'), _vm._v("Your PDF File Here"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        or"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "large": ""
    }
  }, [_vm._v("Select a PDF File")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e051094","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/proxy/create/upload.vue
// module id = 719
// module chunks = 1